module.exports = __webpack_public_path__ + "img/userEquity6.e194177b.png";